// Brand + contact constants for Velarias Tens
// Número de WhatsApp centralizado — fuente única de verdad.
export const WHATSAPP_NUMBER_RAW = "5218116289267";
export const WHATSAPP_NUMBER_DISPLAY = "81 1628 9267";
export const WHATSAPP_NUMBER_FULL_DISPLAY = "+52 81 1628 9267";

// Phone for voice calls (DIFFERENT from WhatsApp). Use ONLY in tel: hrefs / Schema.org telephone.
export const PHONE_CALL_TEL_HREF = "+528189899822";
export const PHONE_CALL_DISPLAY = "81 8989 9822";
export const PHONE_CALL_FULL_DISPLAY = "+52 81 8989 9822";

// Backwards-compat alias — anything using PHONE_TEL_HREF gets the call number.
export const PHONE_TEL_HREF = PHONE_CALL_TEL_HREF;

export const BRAND = {
  name: "Velarias Tens",
  legal: "Eclipse Cubiertas SA de CV",
  // Llamadas
  phoneDisplay: PHONE_CALL_DISPLAY,
  phoneFullDisplay: PHONE_CALL_FULL_DISPLAY,
  phoneTel: PHONE_CALL_TEL_HREF,
  // WhatsApp
  whatsappNumber: WHATSAPP_NUMBER_RAW,
  whatsappDisplay: WHATSAPP_NUMBER_DISPLAY,
  whatsappFullDisplay: WHATSAPP_NUMBER_FULL_DISPLAY,
  emailSales: "ventas@velariastens.com.mx",
  emailTeam: "info@eclipsecubiertas.com",
  address: "Calle San Pedro 157, Bodega 8, Extora Park Flex Space, Col. 4, CP 66367, Sta. Catarina, N.L.",
  addressLines: [
    "Calle San Pedro No. 157, Bodega No. 8",
    "Extora Park Flex Space, Col. 4",
    "CP 66367, Sta. Catarina, N.L.",
  ],
  mapUrl: "https://maps.app.goo.gl/7fqaFjJ1Mn2QLMz77",
  addressShort: "Monterrey, NL",
  hours: "Lun-Vie 8am-8pm | Sáb 9am-2pm | Dom cerrado",
  domain: "velariastens.com.mx",
  social: {
    instagram: "https://www.instagram.com/eclipsecubiertasmx/",
    facebook: "https://www.facebook.com/eclipsecubiertasmx",
    linkedin: "https://www.linkedin.com/company/eclipse-cubiertas",
  },
};

export function buildWhatsAppUrl(message) {
  const text = encodeURIComponent(message || `Hola, me interesa cotizar una velaria / tensoestructura`);
  return `https://wa.me/${BRAND.whatsappNumber}?text=${text}`;
}

export const PROJECT_TYPE_OPTIONS = [
  { value: "malla_sombra", label: "Velaria de malla sombra" },
  { value: "membrana_pvc", label: "Membrana PVC" },
  { value: "tensoestructura_arquitectonica", label: "Tensoestructura arquitectónica" },
  { value: "techo_canchas", label: "Techo para canchas" },
  { value: "cubierta_industrial", label: "Cubierta industrial/comercial" },
  { value: "plaza_centro_comercial", label: "Plaza/centro comercial" },
  { value: "residencial_premium", label: "Residencial premium" },
  { value: "institucion_educativa", label: "Institución educativa" },
  { value: "otro", label: "Otro" },
];

export const SQUARE_METER_OPTIONS = [
  { value: "<100", label: "Menos de 100 m²" },
  { value: "100-300", label: "100–300 m²" },
  { value: "300-600", label: "300–600 m²" },
  { value: "600-1200", label: "600–1200 m²" },
  { value: ">1200", label: "Más de 1200 m²" },
];

export const CITY_OPTIONS = [
  "Monterrey",
  "CDMX",
  "Guadalajara",
  "Querétaro",
  "Puebla",
  "Mérida",
  "Cancún",
  "Tijuana",
  "Otra ciudad",
];

export const NAV_LINKS = [
  { id: "proyectos", label: "Proyectos" },
  { id: "tipos", label: "Tipos de Velaria" },
  { id: "proceso", label: "Proceso" },
  { id: "faq", label: "FAQ" },
  { id: "contacto", label: "Contacto" },
];

// ============================================================
// GALLERY — CORREGIDO tras audit visual 1x1
// Categorías: canchas | comercial | industrial | educativo | residencial
// Se eliminaron nombres de proyecto inventados. Se mantuvieron solo los
// que vienen en el nombre del archivo (gradas Avispones, Torre Benavides)
// o que se identificaron visualmente (Rivero Seminuevos).
// ============================================================
export const GALLERY_ITEMS = [
  { src: "/images/galeria_tensoestructura_01.jpg", title: "Cubierta para cancha deportiva", location: "Monterrey, NL", m2: "1,420 m²", cat: "canchas" },
  { src: "/images/galeria_velaria_cancha_02.jpg", title: "Canchas de pádel", location: "Guadalajara, JAL", m2: "860 m²", cat: "canchas" },
  { src: "/images/galeria_tensoestructura_03.jpg", title: "Cancha de pádel techada", location: "CDMX", m2: "1,100 m²", cat: "canchas" },
  { src: "/images/galeria_velaria_04.jpg", title: "Cancha multiuso con área de sombra", location: "San Pedro, NL", m2: "580 m²", cat: "canchas" },
  { src: "/images/galeria_tensoestructura_05.jpg", title: "Terraza residencial de lujo", location: "San Pedro, NL", m2: "320 m²", cat: "residencial" },
  { src: "/images/galeria_velaria_cancha_06.jpg", title: "Gradas y cancha de pádel", location: "Monterrey, NL", m2: "540 m²", cat: "canchas" },
  { src: "/images/galeria_tensoestructura_grande_07.jpg", title: "Plaza comercial con cubierta textil", location: "Monterrey, NL", m2: "1,210 m²", cat: "comercial" },
  { src: "/images/galeria_velaria_08.jpg", title: "Plaza comercial con canchas de pádel", location: "Monterrey, NL", m2: "920 m²", cat: "comercial" },
  { src: "/images/galeria_tensoestructura_09.jpg", title: "Cancha deportiva cubierta", location: "CDMX", m2: "780 m²", cat: "canchas" },
  { src: "/images/galeria_velaria_10.jpg", title: "Instalación deportiva con gradas", location: "Puebla, PUE", m2: "640 m²", cat: "canchas" },
  { src: "/images/galeria_tensoestructura_11.jpg", title: "Plaza comercial multinivel", location: "Cancún, QROO", m2: "1,310 m²", cat: "comercial" },
  { src: "/images/galeria_velaria_12.jpeg", title: "Terraza residencial con alberca", location: "Monterrey, NL", m2: "220 m²", cat: "residencial" },
  { src: "/images/galeria_tensoestructura_13.jpg", title: "Canchas deportivas techadas", location: "Tijuana, BC", m2: "780 m²", cat: "canchas" },
  { src: "/images/galeria_velaria_14.jpg", title: "Área recreativa con canchas y playground", location: "Querétaro, QRO", m2: "460 m²", cat: "canchas" },
  { src: "/images/galeria_tensoestructura_15.jpg", title: "Estacionamiento institucional cubierto", location: "Monterrey, NL", m2: "590 m²", cat: "educativo" },
  { src: "/images/proyecto_gradas_deportivas_avispones.jpg", title: "Gradas deportivas Avispones", location: "Monterrey, NL", m2: "620 m²", cat: "canchas" },
  { src: "/images/proyecto_torre_benavides_terraza_01.jpeg", title: "Torre Benavides — Terraza residencial", location: "Monterrey, NL", m2: "340 m²", cat: "residencial" },
  { src: "/images/proyecto_hero_estacionamiento.jpeg", title: "Automotriz Rivero Seminuevos", location: "Monterrey, NL", m2: "880 m²", cat: "comercial" },
  { src: "/images/proyecto_skycover_ingenieria_estructural.jpg", title: "Pabellón público con cubierta textil", location: "Monterrey, NL", m2: "450 m²", cat: "comercial" },
];

export const GALLERY_FILTERS = [
  { id: "todos", label: "Todos" },
  { id: "canchas", label: "Canchas" },
  { id: "comercial", label: "Comercial" },
  { id: "industrial", label: "Industrial" },
  { id: "educativo", label: "Educativo" },
  { id: "residencial", label: "Residencial" },
];

export const MODELS = [
  {
    id: "malla_sombra",
    projectTypeKey: "malla_sombra",
    title: "Velaria de Malla Sombra",
    desc: "Semi impermeable, ventilada, protección UV 95%.",
    useCase: "Ideal para canchas deportivas, andadores y espacios abiertos.",
    badge: "Vida útil 20 años",
    img: "/images/proyecto_tensoestructura_velaria_02.jpeg",
  },
  {
    id: "membrana_pvc",
    projectTypeKey: "membrana_pvc",
    title: "Velaria de Membrana PVC",
    desc: "100% impermeable, máxima durabilidad.",
    useCase: "Ideal para plazas, lobbies y centros comerciales.",
    badge: "Vida útil hasta 30 años",
    img: "/images/galeria_tensoestructura_05.jpg",
  },
  {
    id: "arquitectonica",
    projectTypeKey: "tensoestructura_arquitectonica",
    title: "Tensoestructura Arquitectónica",
    desc: "Formas libres imposibles con estructuras tradicionales.",
    useCase: "Ideal para grandes espacios desde 100 m².",
    badge: "Simulación en túnel de viento",
    img: "/images/nicho_arquitectura_textil_deportivo.jpg",
  },
  {
    id: "canchas",
    projectTypeKey: "techo_canchas",
    title: "Techo para Canchas Deportivas",
    desc: "Especialistas en canchas de padel, tenis y basketball.",
    useCase: "Ideal para clubes deportivos y escuelas.",
    badge: "Instalación rápida garantizada",
    img: "/images/nicho_diseno_impresionante.jpg",
  },
  {
    id: "industrial",
    projectTypeKey: "cubierta_industrial",
    title: "Cubierta Industrial y Comercial",
    desc: "Velarias a medida para grandes espacios.",
    useCase: "Ideal para plantas industriales, plazoletas y accesos corporativos.",
    badge: "Proyectos desde 100 m²",
    img: "/images/galeria_tensoestructura_01.jpg",
  },
];

// NICHES — corregidos: "viales_culturales" ahora usa el pabellón (antes
// se había asignado una cancha deportiva). "Industria" usa una imagen de
// estructura corporativa/industrial real.
export const NICHES = [
  { id: "canchas", projectTypeKey: "techo_canchas", title: "Canchas Deportivas", desc: "Cubiertas para padel, tenis, basketball y multiusos.", img: "/images/nicho_canchas_deportivas.jpg" },
  { id: "plazas", projectTypeKey: "plaza_centro_comercial", title: "Plazas y Centros Comerciales", desc: "Arquitectura textil que define identidad y confort climático.", img: "/images/galeria_tensoestructura_11.jpg" },
  { id: "industria", projectTypeKey: "cubierta_industrial", title: "Industria y Corporativos", desc: "Cubiertas para accesos, andenes, patios y áreas logísticas.", img: "/images/galeria_tensoestructura_grande_07.jpg" },
  { id: "educativo", projectTypeKey: "institucion_educativa", title: "Instituciones Educativas", desc: "Patios, canchas y gradas cubiertas para escuelas y universidades.", img: "/images/proyecto_velaria_monterrey_01.jpg" },
  { id: "residencial", projectTypeKey: "residencial_premium", title: "Residencial Premium", desc: "Terrazas, albercas y roof gardens con diseño a medida.", img: "/images/proyecto_skycover_residencial.jpg" },
  { id: "viales", projectTypeKey: "otro", title: "Espacios Viales y Culturales", desc: "Estaciones, accesos, foros y plazas culturales.", img: "/images/proyecto_skycover_ingenieria_estructural.jpg" },
];

export const FEATURES = [
  { icon: "Award", title: "Premio IFAI 2021", desc: "Reconocimiento internacional por innovación en arquitectura textil." },
  { icon: "Wind", title: "Simulación de túnel de viento", desc: "Cada proyecto se valida ante cargas reales de viento y nieve." },
  { icon: "FileText", title: "Memoria de cálculo", desc: "Entregamos cálculo estructural firmado por ingenieros certificados." },
  { icon: "ShieldCheck", title: "Garantía extendida", desc: "Garantía por escrito en estructura y membrana instalada." },
  { icon: "Globe2", title: "Cobertura nacional", desc: "+30 ciudades con proyectos instalados en México y Latinoamérica." },
  { icon: "Layers", title: "Materiales importados", desc: "Dickson, Sioen, Serge Ferrari, Polyfab, Verseidag." },
];

export const FAQ_ITEMS = [
  {
    q: "¿Cuánto tarda la instalación de una velaria?",
    a: "Depende del tamaño y complejidad. Proyectos pequeños (hasta 300 m²) se instalan en 3-7 días una vez fabricada la membrana. Proyectos grandes o tensoestructuras toman de 3 a 8 semanas desde diseño hasta entrega, incluyendo ingeniería, fabricación en planta e instalación.",
  },
  {
    q: "¿Qué garantía ofrecen?",
    a: "Entregamos garantía por escrito: 10 años sobre estructura metálica y 5-10 años sobre membrana (según material). Te entregamos manual de mantenimiento preventivo y soporte técnico post-instalación.",
  },
  {
    q: "¿Cuál es la vida útil real de una velaria?",
    a: "Malla sombra arquitectónica: 15-20 años. Membrana PVC de primer nivel (Ferrari, Sioen, Dickson): 20-30 años. La vida útil depende del material, la exposición UV, el mantenimiento y la calidad del diseño estructural.",
  },
  {
    q: "¿Cuánto cuesta por metro cuadrado?",
    a: "El costo depende del tipo de membrana, la complejidad estructural y la ubicación. Rangos orientativos: malla sombra desde $600 MXN/m², membrana PVC desde $1,500 MXN/m², tensoestructuras arquitectónicas desde $3,500 MXN/m². Te damos un precio cerrado tras visita técnica.",
  },
  {
    q: "¿Tienen cobertura fuera de Monterrey?",
    a: "Sí. Trabajamos en todo México. Hemos instalado en CDMX, Guadalajara, Querétaro, Puebla, Mérida, Cancún, Tijuana y más de 30 ciudades. También proyectos internacionales en Latinoamérica.",
  },
  {
    q: "¿Necesito entregarles planos?",
    a: "No es obligatorio. Si tienes planos o renders, los usamos. Si no, hacemos visita técnica, levantamos medidas y diseñamos desde cero. Entregamos render 3D y memoria de cálculo antes de fabricar.",
  },
  {
    q: "¿Qué mantenimiento requiere una velaria?",
    a: "Muy poco. Lavado anual con agua y jabón neutro, revisión de tensión cada 12-24 meses y retiro de hojas/objetos atrapados. Ofrecemos contratos de mantenimiento preventivo opcionales.",
  },
  {
    q: "¿Están certificados?",
    a: "Sí. Eclipse Cubiertas tiene 20 años de trayectoria, ganó el Premio IFAI 2021 (Industrial Fabrics Association International) y trabaja con ingenieros estructuristas certificados. Entregamos DRO y memoria de cálculo firmada cuando el proyecto lo requiere.",
  },
  {
    q: "¿Con qué materiales trabajan?",
    a: "Solo con marcas de primer nivel: Dickson (Francia), Sioen (Bélgica), Serge Ferrari (Francia), Polyfab (Australia), Verseidag (Alemania). Importamos directo, garantizando autenticidad y calidad.",
  },
  {
    q: "¿Cómo es el proceso de trabajo?",
    a: "1) Contacto y visita técnica sin costo. 2) Diseño conceptual y render 3D. 3) Propuesta con memoria de cálculo y cotización cerrada. 4) Anticipo + fabricación en planta. 5) Instalación en sitio con equipo propio. 6) Entrega, manual y garantía por escrito.",
  },
];
